import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Container,
  Row,
} from 'reactstrap';
import loadable from '@loadable/component';
import UserAlert from './skin/UserAlert';
import { fetch, isBrowser } from './index/move-blocks';

const Load = loadable(() => import('./common/Load'), { ssr: true });

const env = process.env;
const HOST = env.REACT_APP_HOST || 'gymnavigator.com';
const SITENAME = env.REACT_APP_SITENAME || 'Gym Navigator';
const MAIN = env.REACT_APP_MAIN;

console.log('MAIN: "' + MAIN + '"');

class Skin extends Component {
  constructor(props) {
    super(props);
    const self = this;
    this.state = {
      footer: props.data || {},
    };
    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this);
    if (isBrowser()) {
      setInterval(() => {
        props.onLoad(self.props.loadingStage - 1, () => {
        });
      }, 120000);
      setInterval(() => {
        const adsbygoogle = window.adsbygoogle || [];
        if (!adsbygoogle.length) {
          [].forEach.call(document.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status])'), () => {
            try {
              adsbygoogle.push({});
            } catch (e) {
              console.warn(e);
            }
          });
        }
      }, 2000);
    }
  }

  componentDidMount() {
    const self = this;
    const { props } = this;
    props.onLoad(1);
    if (isBrowser()) {
      const user = sessionStorage.getItem('user');
      if (user) {
        try {
          props.onLogin(JSON.parse(user));
        } catch (e) {
          console.error(e);
        }
      }

      if (env.NODE_ENV !== 'development') {
        const script = document.createElement('script');
        script.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
        script.async = true;
        document.body.appendChild(script);
      }
      const script2 = document.createElement('script');
      script2.src = 'https://cse.google.com/cse.js?cx=e55d6a88ff4b0185a';
      script2.async = true;
      document.body.appendChild(script2);

      const scroll = () => {
        if (self.props.interactive < 2) {
          self.props.onScroll(2);
        }
      }

      document.addEventListener('mousemove', scroll);
      document.addEventListener('touchstart', scroll);
      document.addEventListener('scroll', scroll);
      window.addEventListener('load', () => {
        if (self.props.interactive < 1) {
          self.props.onScroll(1);
        }
      });

      setTimeout(() => {
        document.getElementById('root').classList.add('loaded');
        requestAnimationFrame(() => {
          document.getElementById('splash').classList.add('loaded');
          requestAnimationFrame(() => {
            self.props.onScroll(3);
          });
        });
      }, 10000);
      self.getUserInfo();
    }
  }

  static getDerivedStateFromProps(props) {
    return {
      footer: props.data || {},
    };
  }

  getUserInfo() {
    fetch('/api/auth/account').catch((e) => {
      console.error(e);
    }).then((r) => {
      if (r) {
        r.json().catch(() => {
        }).then((user) => {
          const { props } = this;
          if (user && !user.message) {
            localStorage.setItem('userId', user.id);
            props.onLogin({ isAuthenticated: true, user });
          } else {
            props.onLogin({ isAuthenticated: false, user: null });
          }
        });
      }
    });
  }

  toggle() {
    const { props } = this;
    props.changeMenu(!props.skin.isOpen);
  }

  userMenu() {
    const { props } = this;
    return (props.user.user.menu || []).map((i) => (<NavItem key={i.to}><Link to={i.to} title={i.title}>{i.title}</Link></NavItem>));
  }

  additionalMenu() {
    const { props } = this;
    return (props.menu.items || []).map((i) => (<NavItem key={i.to}><Link to={i.to} title={i.title}>{i.title}</Link></NavItem>));
  }

  logout() {
    sessionStorage.removeItem('user');
    const { props } = this;
    props.onLogin(null);
    fetch('/api/auth/logout');
  }

  render() {
    const { props } = this;
    const { state } = this;
    return (
      <div className="app">
        {props.menu && props.menu.mode !== 'admin1' ? (
          <header>
            <Container>
              <Navbar className="navbar-default navbar-right" expand="md" dark>
                <Link to="/" className="navbar-brand logo" title={SITENAME} aria-label="logo Gym Navigator">
                  {props.amp ? (
                    <amp-img
                      width="32"
                      height="32"
                      layout="responsive"
                      alt="Gym Navigator"
                      src={"https://" + HOST + "/icon-64.png"}
                    />
                  ) : <img src={"https://" + HOST + "/icon-64.png"} alt="G" />}
                  Gym Navigator
                </Link>
                {props.amp ? '' : (
                  <div className="gsc-container">
                    <div className="gcse-search" />
                  </div>
                )}
                {props.amp ? '' : <NavbarToggler className="navbar-toggle" onClick={this.toggle}>menu</NavbarToggler>}
                {props.amp || !MAIN
                  ? ''
                  : (
                    <Collapse isOpen={props.skin.isOpen} navbar>
                      {(props.user && props.user.isAuthenticated)
                        ? (
                          <Nav>
                            {this.additionalMenu()}
                            {this.userMenu()}
                            <NavItem>
                              <Link to="/user/user">
                                {props.user.user && (props.user.user.fullName || props.user.user.email)}
                              </Link>
                            </NavItem>
                            <NavItem>
                              <a
                                href="#logout"
                                onClick={this.logout}
                              >
                                logout
                              </a>
                            </NavItem>
                          </Nav>
                        )
                        : (
                          <Nav>
                            {this.additionalMenu()}
                            <NavItem><Link to="/user/login" title="log in">log in</Link></NavItem>
                            <NavItem><Link to="/user/signup" title="sign up">sign up</Link></NavItem>
                          </Nav>
                        )}
                    </Collapse>
                  )}
              </Navbar>
            </Container>
          </header>
        )
          : null}
        <UserAlert />
        {props.children}
        {props.menu && props.menu.mode !== 'admin' ? (
          <div className="footer">
            <Container>
              <Row>
                <Load
                  type="footer"
                  id={state.footer && state.footer.id}
                  country={state.footer && state.footer.country}
                  data={state.footer}
                  amp={props.amp}
                  static={props.static}
                />
              </Row>
            </Container>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Skin;
